// extracted by mini-css-extract-plugin
export var smallSpinner = "_pz-0";